import React from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";
import {TextField} from "../../../../ui/components";
import {BaseValueInputProps} from "./types";

const MultiTextValueInput: React.FC<BaseValueInputProps> = ({value, valueError, onChange, showLabel = true}) => {
  const display = Array.isArray(value) ? (value as Array<string | number>).join(", ") : String(value ?? "");
  return (
    <Box sx={{flex: 2}}>
      {showLabel && (
        <Text size={12} sx={{color: Colors.grey._700, mb: 0.5}}>
          Values (comma separated)
        </Text>
      )}
      <TextField
        size="small"
        fullWidth
        placeholder="Values"
        value={display}
        onChange={(e) => onChange(e.target.value)}
        error={!!valueError}
      />
    </Box>
  );
};

export default MultiTextValueInput;
